.submenuParent {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #2c2e2f;
  height: 32px;
  border-radius: 4px;
  width: 100%;
  white-space: nowrap;
  transition: background-color 0.2s ease-out 100ms;
  position: relative;
  cursor: pointer;
}

.submenuParent:hover {
  background-color: whitesmoke;
}

.submenuParent[data-disabled="true"] {
  color: var(--color-easil-gray);
  pointer-events: none;
  cursor: not-allowed;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--ctx-menu-icon-margin-end, 16px);
  margin-left: var(--ctx-menu-icon-margin-start, 16px);
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: 4px;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.submenuPanel {
  position: absolute;
  left: 100%;
  top: 0;
  background: white;
  border: solid 1px var(--color-easil-gray-x-light);
  box-shadow: 0 1px 2px 0 rgba(21, 21, 22, 0.12);
  border-radius: 8px;
  padding: 6px;
  width: 200px;
  z-index: 11;
  display: flex;
  flex-direction: column;
}

.submenuOption {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #2c2e2f;
  height: 32px;
  border-radius: 4px;
  width: 100%;
  white-space: nowrap;
  transition: background-color 0.2s ease-out 100ms;
  cursor: pointer;
  overflow: hidden;
}

.optionLabel {
  min-width: 0;
  flex: 1;
}

.submenuOption:hover {
  background-color: whitesmoke;
}

.submenuOption[data-disabled="true"] {
  color: var(--color-easil-gray);
  pointer-events: none;
  cursor: not-allowed;
}

.submenuOption[data-active="true"] {
  background-color: #e3f2fd;
}

.submenuOption[data-active="true"]:hover {
  background-color: #e3f2fd;
}
